module.exports = __webpack_public_path__ + "img/Food-Card-2.7a5f77d2.png";